export const DATEPICKER_DATE_FORMAT = 'YYYY-MM-DD'
export const CLOSED_BUDGET_DATE_FORMAT = 'DD/MM/YYYY'
export const TAG_BUDGET_MIN_DATE = new Date('2000-01-02')
export const TAG_BUDGET_MAX_DATE = new Date('2999-12-31')
